import * as React from "react";

const SvgCloudy = (props) => (
  <svg
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M76.11 40.586C78.503 37.698 80 34.043 80 30c0-9.206-7.461-16.667-16.667-16.667C60.071 5.501 52.347 0 43.333 0 30.912 0 20.508 8.503 17.539 20h-4.206C5.97 20 0 25.97 0 33.333c0 7.362 5.97 13.333 13.333 13.333h23.623a26.607 26.607 0 0 0-2.751 6.666H30c-7.363 0-13.333 5.971-13.333 13.334C16.667 74.029 22.637 80 30 80h50v-6.668H30a6.675 6.675 0 0 1-6.667-6.666A6.671 6.671 0 0 1 30 60h10c0-11.049 8.955-20 20-20 7.702 0 13.991 5.852 14.831 13.332H80v-6.666c-.94-2.26-2.288-4.291-3.894-6.088l.004.008ZM60 33.333c-6.751 0-12.897 2.526-17.585 6.667H13.333c-3.679 0-6.667-2.995-6.667-6.667a6.67 6.67 0 0 1 6.667-6.666h10c0-11.049 8.955-20 20-20 7.702 0 13.991 5.853 14.831 13.333h5.169c5.515 0 10 4.485 10 10 0 2.437-.911 4.642-2.363 6.377v.002c-3.223-1.906-6.953-3.046-10.97-3.046Z"
      fill="#fff"
    />
  </svg>
);

export default SvgCloudy;
